export const maxAssetsToDisplay = 20;
export const maxAssetsInView = 4;
